import React, { useEffect, useState } from "react";
import logo from "../../resource/7.png";
import CommonFormFields from "./CommonFormFields";
import Swal from "sweetalert2";
import axios from "axios";
import apiClient from "@/api/client";

const DanaAtHome = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        mobileNumber: "",
        wtNumber: "",
        email: "",
        date: "",
        specific_event: "",
        other: "",
        dana_for_lunch: false,
        dana_for_morning: false,
        birthday: false,
        sevenday: false,
        warming: false,
        threemonths: false,
        oneyear: false,
        annually: false,
        weddings: false,
        ip_address: "",
    });

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchIP = async () => {
            try {
                const response = await axios.get("https://api.ipify.org?format=json");
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    ip_address: response.data.ip, // Set the IP address
                }));
            } catch (error) {
                console.error("Error fetching IP address:", error);
            }
        };

        fetchIP();
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: checked,
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Validate First Name
        if (!formData.firstName) newErrors.firstName = "First Name is required";
        else if (!/^[A-Za-z\s\-]+$/.test(formData.firstName)) newErrors.firstName = "First Name should contain only letters, spaces, or hyphens";

        // Validate Last Name
        if (!formData.lastName) newErrors.lastName = "Last Name is required";
        else if (!/^[A-Za-z\s\-]+$/.test(formData.lastName)) newErrors.lastName = "Last Name should contain only letters, spaces, or hyphens";

        // Validate Mobile Number
        if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile Number is required";
        else if (!/^\d{10}$/.test(formData.mobileNumber)) newErrors.mobileNumber = "Mobile Number should be 10 digits";

        if (!formData.date) newErrors.date = "Date is required";

        // Validate Email
        if (!formData.email) newErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Invalid email format";

        // Validate WT Number (assuming it's a string with specific format)
        if (!formData.wtNumber) newErrors.wtNumber = "WhatsApp Number is required";
        else if (!/^\d{10}$/.test(formData.wtNumber)) newErrors.wtNumber = "WhatsApp Number should be 10 digits";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateSelectionForm = () => {
        const { sevenday, threemonths, oneyear, annually, birthday, warming, weddings } = formData;

        // Check if at least one item is selected from the first group
        const isFirstGroupValid = sevenday || threemonths || oneyear || annually;

        // Check if at least one item is selected from the second group
        const isSecondGroupValid = birthday || warming || weddings;

        // If either group is not valid, return false
        if (!isFirstGroupValid || !isSecondGroupValid) {
            return false;
        }

        // If all validations pass, return true
        return true;
    };

    const DanaTimeValidation = () => {
        if (!formData.dana_for_morning && !formData.dana_for_lunch) {
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const validateAll = () => {
        const isFormValid = validateForm();
        const isTimeValid = DanaTimeValidation();
        const isSelectionValid = validateSelectionForm();

        if (!isFormValid) {
            Swal.fire({
                icon: "error",
                title: "Validation Error",
                text: "Check the form",
            });
            return false;
        }

        if (!isTimeValid) {
            Swal.fire({
                icon: "error",
                title: "Validation Error",
                text: "Select at least one time ( Morning / Lunch ) ",
            });
            return false;
        }

        if (!isSelectionValid) {
            Swal.fire({
                icon: "error",
                title: "Validation Error",
                text: "Please select at least one item under the Punyannumodana for the deceased.",
            });
            return false;
        }

        return true; // All validations passed
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateAll()) {
            return; // Stop execution if validation fails
        }

        setLoading(true);

        try {
            const response = await apiClient.post('/danaAtHome-request', formData);

            console.log("Form submitted successfully:", response.data);
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Form submitted successfully!",
            });

            // Reset the form
            setFormData({
                firstName: "",
                lastName: "",
                mobileNumber: "",
                wtNumber: "",
                email: "",
                date: "",
                dana_for_lunch: false,
                dana_for_morning: false,
                specific_event: "",
                other: "",
                birthday: false,
                sevenday: false,
                warming: false,
                threemonths: false,
                oneyear: false,
                annually: false,
                weddings: false,
                ip_address: "",
            });
        } catch (error) {
            console.error("Error submitting form:", error);
            let errorMessage = "Something went wrong!";
            if (error.response) {
                errorMessage = error.response.data.message || "An error occurred while submitting the form.";
            } else if (error.request) {
                errorMessage = "No response from the server. Please try again later.";
            }
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: errorMessage,
            });
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="form-page dark-gold ">
            <form onSubmit={handleSubmit}>
                <div className="form-title">
                    <img src={logo} alt="" width={200} />
                    <div className="details">
                        <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
                        <h2 className="h4">Dana at Home Request Form</h2>
                    </div>
                </div>

                <p className="font-p mt-6">
                    Please fill in the following details and we will contact you.
                </p>

                <CommonFormFields
                    formData={formData}
                    handleInputChange={handleInputChange}
                    errors={errors}
                />

                <p className="font-p mt-5">
                    Please select the appropriate box for your Dana request.{" "}
                </p>

                <div className="form-box mt-5">
                    <div className="form-item">
                        <input
                            type="checkbox"
                            id="dana_for_morning"
                            name="dana_for_morning"
                            className="checkbox"
                            checked={formData.dana_for_morning}
                            onChange={handleInputChange}
                        />
                        <label htmlFor="morning">Dana for Morning</label>
                    </div>
                    <div className="form-item">
                        <input
                            type="checkbox"
                            id="dana_for_lunch"
                            name="dana_for_lunch"
                            className="checkbox"
                            checked={formData.dana_for_lunch}
                            onChange={handleInputChange}
                        />
                        <label htmlFor="time">Dana fo Lunch</label>
                    </div>
                </div>

                <p className="font-p mt-5">
                    Please indicate the date you wish have the Dana at your home..{" "}
                </p>
                <div className="form-box">
                    <div className="form-item">
                        <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            min={new Date().toISOString().split('T')[0]} // Set min to today's date
                        />
                        
                        {errors.date && <span className="error">{errors.date}</span>}
                    </div>
                </div>




                <p className="font-p mt-5">
                    Please indicate if you have any specific event or purpose for the
                    sermon
                </p>
                <div className="form-box mt-5">
                    <div className="form-item">
                        <input type="text" id="specific_event" name="specific_event" value={formData.specific_event} onChange={handleInputChange} />
                        <label htmlFor="specific_event"></label>
                    </div>
                </div>
                <p className="font-p mt-5">
                    Punyannumodana for the deceased
                </p>

                <div className="selection mt-5">
                    <div className="checkbox-box">
                        <label htmlFor="sevenday"> 7 Day</label>
                        <input
                            type="checkbox"
                            id="sevenday"
                            name="sevenday"
                            className="checkbox"
                            checked={formData.sevenday}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="checkbox-box">
                        <label htmlFor="threemonths"> 3 Months</label>
                        <input
                            type="checkbox"
                            id="threemonths"
                            name="threemonths"
                            className="checkbox"
                            checked={formData.threemonths}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="checkbox-box">
                        <label htmlFor="oneyear"> 1 Year</label>
                        <input
                            type="checkbox"
                            id="oneyear"
                            name="oneyear"
                            className="checkbox"
                            checked={formData.oneyear}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="checkbox-box">
                        <label htmlFor="annually"> Annually</label>
                        <input
                            type="checkbox"
                            id="annually"
                            name="annually"
                            className="checkbox"
                            checked={formData.annually}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <div className="selection mt-5">
                    <div className="checkbox-box">
                        <label htmlFor="birthday"> Birthday</label>
                        <input
                            type="checkbox"
                            id="birthday"
                            name="birthday"
                            className="checkbox"
                            checked={formData.birthday}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="checkbox-box">
                        <label htmlFor="warming"> House Warming</label>
                        <input
                            type="checkbox"
                            id="warming"
                            name="warming"
                            className="checkbox"
                            checked={formData.warming}
                            onChange={handleInputChange}
                        />
                    </div>


                    <div className="checkbox-box">
                        <label htmlFor="weddings">Weddings Anniversary</label>
                        <input
                            type="checkbox"
                            id="weddings"
                            name="weddings"
                            className="checkbox"
                            checked={formData.weddings}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>


                <div className="form-box1 mt-5">
                    <div className="form-item1">
                        <label htmlFor="#">Other (Please specify)</label>
                        <input
                            type="text"
                            id="other"
                            name="other"
                            value={formData.other}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                </button>

                <p className="font-p mt-5 pb-4">
                    Thank you for your kind support. We will be in touch with you shortly.
                </p>
            </form>
        </div>
    )
}

export default DanaAtHome